// 报表
import adReport from '@/views/qianchuan/report/adReport'
export default {
  path: '/qianchuan/report',
  name: 'qcreport',
  component: resolve => require(['@/views/qianchuan/report'], resolve),
  meta: {
    keepAlive: true,
    title: '报表',
    code: 'page:report',
    activeName: '/report',
    permission: 'report',
    name: 'qcadReport'
  },
  children: [
    {
      path: 'base',
      name: 'base',
      component: resolve => require(['@/views/qianchuan/report/base'], resolve),
      meta: {
        keepAlive: true,
        title: '基础报表',
        iconName: 'icon-menuAd',
        permission: 'adReport',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'qcaccount',
          title: '广告账户'

        },
        {
          name: 'qcgroup',
          title: '广告组'
        },
        {
          name: 'qcplan',
          title: '广告计划'
        },
        {
          name: 'qcmaterial',
          title: '素材报表'
        }
      ],
      children: [
        {
          path: 'qcaccount',
          name: 'qcaccount',
          component: adReport,
          meta: {
            keepAlive: true,
            title: '广告账户',
            permission: 'adReport'
          }
        },
        {
          path: 'qcgroup',
          name: 'qcgroup',
          component: adReport,
          meta: {
            keepAlive: true,
            title: '广告组',
            permission: 'adReport'
          }
        },
        {
          path: 'qcplan',
          name: 'qcplan',
          component: adReport,
          meta: {
            keepAlive: true,
            title: '广告计划',
            permission: 'adReport'
          }
        },
        {
          path: 'qcmaterial',
          name: 'qcmaterial',
          component: resolve => require(['@/views/qianchuan/report/materialReport'], resolve),
          meta: {
            keepAlive: true,
            title: '素材报表',
            iconName: 'icon-sucaibaobiao',
            permission: 'imgReport'
          }
        }
        // {
        //   path: 'adReport',
        //   name: 'adReport',
        //   component: adReport,
        //   meta: {
        //     keepAlive: true,
        //     title: '广告报表',
        //     iconName: 'icon-menuAd',
        //     permission: 'adReport'
        //   }
        // },
      ]
    }
    // {
    //   path: 'ad',
    //   name: 'qcadReport',
    //   component: resolve => require(['@/views/qianchuan/report/adReport'], resolve),
    //   meta: {
    //     keepAlive: true,
    //     title: '广告报表',
    //     iconName: 'icon-menuAd',
    //     permission: 'adReport'
    //   }
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/router/qianchuan/report.js